module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-5.0a2005b8.jpg";